<div class="tdg-tab-content h-100">
  <div class="content-wrapper d-flex flex-column h-100 w-100" *ngIf="isTSuiteView">
    <div class="table-wrapper flex-grow-1">
      <div *ngIf="isLoading" class="h-100 v-center">
        <app-loading [text]="'Loading...'"></app-loading>
      </div>
      <ng-container *ngIf="!isLoading">
        <div class="suites-toolbar" *ngIf="accordionSections.length">
          <span class="suites-toolbar-title">Version History</span>
          <app-simple-pager
            [start]="pagerStart"
            [end]="pagerEnd"
            [total]="accordionSections.length"
            [disablePrev]="disablePrevPage"
            [disableNext]="disableNextPage"
            (prev)="prevPage()"
            (next)="nextPage()"
          ></app-simple-pager>
        </div>
        <app-accordion-table-view
          [sections]="pagedAccordionSections"
          typeId="tdg_version_control_suites"
          [itemLabel]="'Test Cases'"
          [showHeader]="false"
          [showPagination]="false"
          (sectionExpand)="onSectionExpand($event)"
          (tableActions)="onTableActions($event)">
        </app-accordion-table-view>
      </ng-container>
    </div>
  </div>

  <div class="content-wrapper w-100 v-center" *ngIf="isLoading && !isTSuiteView">
    <app-loading
      [text]="'Retrieving Test Case Details'">
    </app-loading>
  </div>

  <div *ngIf="!isTSuiteView && !isLoading" class="content-wrapper w-100">
    <div class="actions-header">
      <div class="header-left" (click)="goBackToDetailList()">
        <button class="back-button">
          <i class="bi bi-arrow-left"></i>
        </button>
        <span class="test-case-title">{{
          selectedTestCaseDetail?.testCaseId || "TC name here"
        }}</span>
      </div>
    </div>
    <div class="tc-table-toolbar">
      <app-simple-pager
        *ngIf="testCaseData.length"
        [start]="tcPagerStart"
        [end]="tcPagerEnd"
        [total]="testCaseData.length"
        [disablePrev]="tcDisablePrevPage"
        [disableNext]="tcDisableNextPage"
        (prev)="tcPrevPage()"
        (next)="tcNextPage()"
      ></app-simple-pager>
      <div class="tc-table-toolbar-actions">
        <div [hidden]="isEditMode" class="d-flex">
          <button class="btn-accello-secondary" (click)="onPersist()">
            Persist
          </button>
          <button class="btn-accello-secondary mx-2" (click)="onEdit()">
            Edit
          </button>
          <div class="dropdown">
            <button
              class="btn-accello-secondary"
              type="button"
              (click)="toggleDownloadMenu()"
            >
              Download
              <i class="bi bi-chevron-down ml-5px"></i>
            </button>
            <div class="dropdown-menu" [ngClass]="{ show: showDownloadMenu }">
              <a class="dropdown-item" (click)="onDownloadTestCase('xlsx')"
                >Download as Excel</a
              >
            </div>
          </div>
        </div>

        <div *ngIf="isEditMode" class="d-flex">
          <div class="dropdown">
            <button
              class="btn-accello-secondary"
              type="button"
              (click)="toggleInsertMenu()"
            >
              Insert
              <i class="bi bi-chevron-down ml-5px mt-1"></i>
            </button>
            <div class="dropdown-menu" [ngClass]="{ show: showInsertMenu }">
              <a class="dropdown-item" (click)="insert('column')">Column</a>
              <a class="dropdown-item" (click)="insert('row')">Row</a>
            </div>
          </div>

          <button
            class="btn-accello-primary-outlined mx-2"
            type="button"
            (click)="delete()"
          >
            Delete
          </button>

          <button
            class="btn-accello-secondary"
            type="button"
            (click)="saveData()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <div class="tc-table flex-grow-1">
      <app-zorro-table
        [enableHorizontalScroll]="true"
        [data]="pagedTestCaseData"
        [columns]="testCaseColumns"
        [options]="tcTableOptions"
        (handleActions)="onTestCaseAction($event)"
      >
      </app-zorro-table>
    </div>
  </div>
</div>
